export function Toast({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div className="toast pointer-events-none fixed left-1/2 top-[14%] z-40 rounded-md bg-tgtext px-4 py-2 text-sm font-semibold text-tgbg shadow-lg">
      {message}
    </div>
  );
}
